export const folderActionsCopy = {
  newSubfolder: 'New Subfolder',
  rename: 'Rename',
  delete: 'Delete',
};
